const FIXED_WIDTH_DESKTOP = 400
const FIXED_WIDTH_MOBILE = 200
const WIDTH_DESKTOP = 500

/**
 * @param isFixedWidth
 * @param isMobileScreen
 * @returns {string}
 */
export default function getWidthCardUtil ({
  isFixedWidth,
  isMobileScreen
}) {
  let width
  if (isFixedWidth && isMobileScreen) {
    width = `${FIXED_WIDTH_MOBILE}px`
  } else if (isFixedWidth) {
    width = `${FIXED_WIDTH_DESKTOP}px`
  } else if (isMobileScreen) {
    width = '100%'
  } else {
    width = `${WIDTH_DESKTOP}px`
  }

  return width
}
